import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { saveAs } from 'file-saver'
import { combineLatest } from 'rxjs'
import { filter, map, switchMap, take, tap } from 'rxjs/operators'
import { EbUserIdService } from '../../auth/services/eb-user-id.service'
import * as EbCartAction from '../store/actions/eb-cart.action'
import { EbCartAdapter } from './connectors/eb-cart.adapter'
import { EbActiveCartService } from './eb-active-cart.service'

@Injectable()
export class EbQuickOrderService {
  constructor(
    protected cartAdapter: EbCartAdapter,
    protected store: Store,
    protected userIdService: EbUserIdService,
    protected activeCartService: EbActiveCartService,
    protected globalMessageService: GlobalMessageService
  ) {}

  downloadCsvTemplate() {
    combineLatest([this.userIdService.getUserId(), this.activeCartService.getActiveCartId()])
      .pipe(
        switchMap(([userId, cartId]) => {
          return this.cartAdapter.getCsvTemplate(cartId, userId)
        })
      )
      .subscribe(document => {
        saveAs(document, 'csv_template', { autoBom: false })
      })
  }

  uploadCsvFile(file) {
    return combineLatest([
      this.userIdService.getUserId(),
      this.activeCartService.getActiveCartId()
    ]).pipe(
      filter(() => this.checkFile(file)),
      map(([userId, cartId]) => {
        const formData = new FormData()
        formData.append('file', file)
        this.store.dispatch(
          new EbCartAction.EbCartCsvUpload({
            userId,
            cartId,
            formData
          })
        )
      })
    )
  }

  checkFile(file: File): boolean {
    if (!this.isFileAllowed(file.name)) {
      this.globalMessageService.add(
        { key: 'formErrors.file.invalid.contentType' },
        GlobalMessageType.MSG_TYPE_ERROR
      )
      return false
    }
    return true
  }

  private isFileAllowed(fileName: string): boolean {
    const regex = /(?:\.([^.]+))?$/
    const extension = regex.exec(fileName)
    if (extension) {
      if ('.csv' === extension[0]?.toLowerCase()) {
        return true
      }
    }
    return false
  }
}
